module.exports = __webpack_public_path__ + "static/img/create-new-application.a29fe41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/intro/create-new-application.png
// module id = lLiE
// module chunks = 1